<template>
	<div class="rc">
		<div class="diaodu" @click="openZh">指挥调度</div>
		<div class="diaodu-log" :style="{opacity: showZh ? 1 : 0}">
			<div class="close" @click="closezh"></div>
			<div class="zh-title">指挥调度</div>
			<div class="select-list">
				<div class="select-item" :class="{active: secactive.value == item.value}" v-for="item in zhList" :key="item.value" @click="changeZh(item)">
					{{ item.name }}
				</div>
			</div>
			<div class="human-list">
				<div class="human-item" v-for="item in 3" :key="item">
					<img src="@/assets/temimg15/log/avatar.png" class="human-avatar" alt="">
					<div class="human-right">
						<div class="human-text">张三(区域负责人)</div>
						<div class="human-text">电话：1380000000</div>
						<div class="human-text">区域：{{ secactive.name }}</div>
					</div>
				</div>
			</div>
		</div>
		<div ref="cmain1" class="cmain" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
	</div>
</template>

<script>
import * as methods from './method.js'
export default {
	name: "template.scope120",
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		valuemap: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			isList: true,
			timer: null,
			defaultdata: [
				{ value1: '健康证临期', value2: '76', value3: '东山县', value4: '百分比' },
				{ value1: '许可证临期', value2: '22', value3: '东山县', value4: '百分比' },
				{ value1: '从业人员未有健康证', value2: '36', value3: '东山县', value4: '百分比' },
				{ value1: '从业人员未上报', value2: '45', value3: '东山县', value4: '百分比' },
				{ value1: '两个责任', value2: '43', value3: '东山县', value4: '百分比' },
				{ value1: '供应商未上传', value2: '67', value3: '东山县', value4: '百分比' },
				{ value1: '承诺书未上传', value2: '99', value3: '东山县', value4: '百分比' },
				{ value1: '共管码未发放', value2: '64', value3: '东山县', value4: '百分比' },
				{ value1: '共管码未使用', value2: '34', value3: '东山县', value4: '百分比' },
				{ value1: '共管码已发放', value2: '55', value3: '东山县', value4: '百分比' },
				{ value1: '店铺视频异常数', value2: '78', value3: '东山县', value4: '百分比' },
				{ value1: 'D级信用企业占比超量', value2: '34', value3: '东山县', value4: '百分比' },
				{ value1: '健康证临期', value2: '56', value3: '杏陈镇', value4: '百分比' },
				{ value1: '许可证临期', value2: '44', value3: '杏陈镇', value4: '百分比' },
				{ value1: '从业人员未有健康证', value2: '32', value3: '杏陈镇', value4: '百分比' },
				{ value1: '从业人员未上报', value2: '88', value3: '杏陈镇', value4: '百分比' },
				{ value1: '两个责任', value2: '65', value3: '杏陈镇', value4: '百分比' },
				{ value1: '供应商未上传', value2: '44', value3: '杏陈镇', value4: '百分比' },
				{ value1: '承诺书未上传', value2: '35', value3: '杏陈镇', value4: '百分比' },
				{ value1: '共管码未发放', value2: '78', value3: '杏陈镇', value4: '百分比' },
				{ value1: '共管码未使用', value2: '32', value3: '杏陈镇', value4: '百分比' },
				{ value1: '共管码已发放', value2: '34', value3: '杏陈镇', value4: '百分比' },
				{ value1: '店铺视频异常数', value2: '55', value3: '杏陈镇', value4: '百分比' },
				{ value1: 'D级信用企业占比超量', value2: '66', value3: '杏陈镇', value4: '百分比' },
				{ value1: '健康证临期', value2: '32', value3: '樟塘镇', value4: '百分比' },
				{ value1: '许可证临期', value2: '47', value3: '樟塘镇', value4: '百分比' },
				{ value1: '从业人员未有健康证', value2: '86', value3: '樟塘镇', value4: '百分比' },
				{ value1: '从业人员未上报', value2: '34', value3: '樟塘镇', value4: '百分比' },
				{ value1: '两个责任', value2: '56', value3: '樟塘镇', value4: '百分比' },
				{ value1: '供应商未上传', value2: '77', value3: '樟塘镇', value4: '百分比' },
				{ value1: '承诺书未上传', value2: '54', value3: '樟塘镇', value4: '百分比' },
				{ value1: '共管码未发放', value2: '32', value3: '樟塘镇', value4: '百分比' },
				{ value1: '共管码未使用', value2: '23', value3: '樟塘镇', value4: '百分比' },
				{ value1: '共管码已发放', value2: '75', value3: '樟塘镇', value4: '百分比' },
				{ value1: '店铺视频异常数', value2: '32', value3: '樟塘镇', value4: '百分比' },
				{ value1: 'D级信用企业占比超量', value2: '34', value3: '樟塘镇', value4: '百分比' },
			],
			valueMap: [
				{ name: '名称', key: "value1" },
				{ name: '数值', key: "value2" },
				{ name: '地区', key: 'value3' },
				{ name: '单位', key: 'value4' }
			],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
			autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
			activeCity: '',
			citylist: [],
			showZh: false,
			zhList: [
				{ name: '西埔所', value: 1 },
				{ name: '铜陵所', value: 2 },
				{ name: '陈城所', value: 3 },
				{ name: '杏陈所', value: 4 },
				{ name: '康美所', value: 5 },
				{ name: '池园所', value: 6 },
				{ name: '樟塘所', value: 7 },
				{ name: '前楼所', value: 8 },
			],
			secactive: { name: '西埔所', value: 1 },
		}
	},
	beforeDestroy() {
		clearInterval(this.timer)
		this.timer = null
	},
	methods: {
		...methods,
		cDrawCircle() {
			var echarts = require("echarts");
			clearInterval(this.timer)
			this.timer = null
			var TmyChart = echarts.init(this.$refs.cmain1);
			let data1 = [];
			let data2 = [];
			let legend = [];
			let vname = this.citylist[this.activeCity].label
			let vdata = this.defaultdata.filter(item => item.value3 == vname)
			let unit = vdata.value4
			const colormap = ['#318be3', '#75fafd']
			vdata.forEach((item, i) => {
				if (item.value2 && item.value3) {
					const vdata1 = { name: item.value3, value: item.value2 };
					data1.push(vdata1);
				}
				if (i == 0) {
					if (item.value3) {
						legend.push({
							top: "2%",
							right: "50%",
							itemHeight: 12, //图例的高度  文字左边那个
							itemWidth: 10,
							textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
							data: [{ name: item.value3, icon: "rect" }],
						});
					}
				}
			});
			const xAxis = vdata.map((item) => {
				return item.value1;
			});
			const percent = (11 / xAxis.length) * 100;
			let zoom = [
				{
					id: "scope35", // 唯一的id
					filterMode: "empty",
					xAxisIndex: [0], //滑动条为竖
					mayValueSpan: 11, // 显示数据的条数(默认显示10个)
					type: "slider",
					showDetail: false, //关闭：拖拽时候显示详细数值信息。
					dataBackground: {
						show: false,
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					selectedDataBackground: {
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					backgroundColor: "transparent",
					fillerColor: "transparent",
					borderColor: "transparent",
					start: 0,
					end: percent,
					top: "85%",
					height: "5%",
				},
			];
			var Toption = {
				title: [
					{
						text: unit,
						top: "0",
						left: "0",
						textStyle: {
							color: "#979AA0",
							fontSize: 12,
						},
					},
				],
				tooltip: {
					trigger: "axis",
				},
				grid: {
					left: "5px",
					right: "10px",
					bottom: "0px",
					top: "35px",
					containLabel: true,
				},
				legend: [...legend],
				xAxis: {
					type: "category",
					boundaryGap: true,
					data: vdata.map((item) => item.value1),
					axisLabel: {
						interval: 0,
						width: 55,
						overflow: 'break', //文字超出宽度截断，默认为...
						textStyle: {
							color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
							fontSize: "14",
							lineHeight: 16,
						},
					},
					axisLine: {
						lineStyle: {
							// X 轴颜色配置
							color: "#4792e9",
						},
					},
					axisTick: {
						show: false,
					},
				},
				yAxis: {
					type: "value",
					splitNumber: 4,
					axisLabel: {
						textStyle: {
							color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
						},
					},
					axisLine: {
						show: false,
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: "dashed",
							color: "rgba(231,241,251,.2)",
						},
					},
				},
				series: [
					{
						name: vname,
						type: "bar",
						stack: "total",
						barWidth: 15,
						barGap: "40%",
						backgroundStyle: {
							backgroundColor: "rgba(200, 200, 200, 0.3)",
						},
						showBackground: true,
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									1,
									1,
									[
										{
											offset: 0,
											color: "#0182fc", // 0% 处的颜色
										},
										{
											offset: 0.6,
											color: "#0182fc", // 0% 处的颜色
										},
										{
											offset: 0.9,
											color: "#08315f", // 100% 处的颜色
										},
									],
									false
								),
							},
						},
						// data: [6, 4, 3, 5, 3, 4, 5]
						data: data1,
					},
				],
				// dataZoom: xAxis.length > 11 ? zoom : [],
			};
			TmyChart.clear();
			Toption && TmyChart.setOption(Toption);
			this.timer = setInterval(function () {
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000);
		},
		setlist() {
			this.citylist = [...new Set(this.defaultdata.map((item) => item.value3))].map((item, i) => {
				return {
					label: item,
					key: i
				}
			})
			this.activeCity = 0
			this.$emit('setlist1', this.citylist, 8)
			this.cDrawCircle()
		},
		setActive(i) {
			this.activeCity = i
			this.cDrawCircle()
		},
		openZh() {
			this.showZh = true
		},
		closezh() {
			this.showZh = false
		},
		changeZh(val) {
			this.secactive = val
		}
	},
	mounted() {
		if (this.valuemap && this.valuemap.length) {
			this.valueMap = this.valuemap
		}
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
		this.setData()
		this.$nextTick(() => {
			this.setlist()
			// this.cDrawCircle(); //需要刷新的数据
		});
	},
	watch: {
		valuemap(n) {
			if (n && n.length) {
				this.valueMap = n
			}
		},
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
		defaultdata(n) {
			this.cDrawCircle()
		}
	}
};
</script>

<style scoped lang="scss">
.rc {
	width: 902px;
	height: 240px;
	display: flex;
	padding: 10px 0;
	position: relative;
}

.cmain {
	//   margin: 20px 0 4px;
	width: 100%;
	height: 240px;
}
.diaodu {
	padding: 6px 16px;
	background: #0062C7;
	border-radius: 3px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	font-size: 12px;
	color: #FFFFFF;
	line-height: 12px;
	position: absolute;
	right: 106px;
	top: -34px;
	cursor: pointer;
	pointer-events: auto;
}
.diaodu-log {
	transition: all 0.5s linear;
	opacity: 0;
	position: absolute;
	width: 100%;
	height: 262px;
	background: url(@/assets/temimg15/log/log-bg.png) no-repeat;
	background-size: 100% 100%;
	top: -42px;
	left: 0;
	transform: translateY(-100%);
	.close {
		width: 18px;
		height: 18px;
		cursor: pointer;
		position: absolute;
		right: 24px;
		top: 16px;
	}
	.zh-title {
		font-family: PangMenZhengDao;
		font-weight: 400;
		font-size: 18px;
		color: #FFFFFF;
		line-height: 18px;
		padding: 16px 0 0 44px;
	}
	.select-list {
		display: flex;
		align-items: center;
		margin: 30px 0 0 36px;
		column-gap: 10px;
	}
	.select-item {
		width: 74px;
		height: 29px;
		background: url(@/assets/temimg15/log/normal.png) no-repeat;
		background-size: 100% 100%;
		text-align: center;
		font-family: PingFang SC;
		font-weight: 400;
		font-size: 13px;
		color: #FFFFFF;
		line-height: 29px;
		cursor: pointer;
		&.active {
			background: url(@/assets/temimg15/log/active.png) no-repeat;
			background-size: 100% 100%;
		}
	}
	.human-list {
		display: flex;
		align-items: center;
		margin: 24px 0 0 36px;
		column-gap: 30px;
	}
	.human-item {
		display: flex;
		align-items: center;
		.human-avatar {
			width: 78px;
			height: 104px;
		}
		.human-right {
			width: 157px;
			height: 87px;
			background: url(@/assets/temimg15/log/right-bg.png) no-repeat;
			background-size: 100% 100%;
			margin-left: 24px;
		}
		.human-text {
			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 14px;
			color: #9DD9FF;
			line-height: 14px;
			margin: 12px 0 0 14px;
		}
	}
}
</style>